/* eslint-disable */
import { Scene } from "phaser";
import Easystar from "easystarjs";
import {
  settingCameras,
  spawnMap,
  // spawnPnj,
  generatePathGrid,
  isoToCoord,
  spawnHomeTree,
  spawnLittleHouse,
  spawnLostFire,
  spawnHikari
} from "../../helpers";

export default class MainScene extends Scene {
  constructor(config) {
    super({ key: "movePnjScene", active: true });
    this.config = config;
    // Grid Pathfinder
    this.walkableGrid = [];
    // Module Pathfinding
    this.finder = new Easystar.js();
    // Size of the tiles
    this.size = { x: 35, y: 35 };
    // Hikari
    this.player;

    this.gold;
    this.counterGold = 0;
    this.positionIsoPlayer;
    //
    this.tilesOutput = {
      layerGround: {},
      // layerDynamics: {},
      layerPnj: {}
    };
    this.isSafe = true;
    this.timeX = 0;
    this.timeY = 0;
    this.destination = new Phaser.Geom.Point(0, 0);
    this.isWalking = false;
    this.houses = [];
    this.triggers = [];
    this.victoryPrev = this.config.victory;
    this.newPNJ;
  }

  preload() {
    // Tiles null
    this.load.image("null", "/images/null.png");
    // Tiles Ground
    this.load.image("rock", "/images/tile_rock.png");
    this.load.image("ground", "/images/tile_ground.png");
    // Tiles Chemin
    this.load.image("cheminCroisement", "/images/GroundCroisement.png");
    this.load.image("cheminHorizon", "/images/groundLeaf.png");
    this.load.image("cheminVerticalLuciole", "/images/groundLeaf2.png");
    this.load.image("cheminVertical", "/images/groundLeaf3.png");
    // Pnj
    this.load.multiatlas("pnj", "/assets/pnj1.json", "/assets");
    //Hikari
    this.load.multiatlas("hikari", "/assets/hikari.json", "/assets");
    // Home
    this.load.image("treeCity", "/images/big_tree.png");
    this.load.image("homeFireA_off", "/images/TroncLightOff.png");
    this.load.image("homeFireA_on", "/images/TroncLightOn.png");
    this.load.image("homeFireB_off", "/images/TroncLightOffLeft.png");
    this.load.image("homeFireB_on", "/images/TroncLightOnLeft.png");
    // Bush Angle
    this.load.image("bush", "/images/bush.png");
    this.load.image("angleTop", "/images/BigBrushTop.png");
    this.load.image("angleDown", "/images/Brush_down.png");
    this.load.image("angleLeft", "/images/BigBrushLeft.png");
    this.load.image("angleRight", "/images/BigBrushRight.png");
    // Bush Longeur
    this.load.image("longueurTopLeft", "/images/BrushTopLeft.png");
    this.load.image("longueurTopRight", "/images/BrushTopRight.png");
    this.load.image("longueurDownLeft", "/images/BrushDownLeft.png");
    this.load.image("longueurDownRight", "/images/BrushDownRight.png");
    // Music
    this.load.audio("ambianceGame", "audio/game.mp3");
  }

  create() {
    this.sound.add("ambianceGame");
    this.sounds = this.sound.play("ambianceGame");
    spawnMap(
      this,
      this.config.map,
      this.tilesOutput,
      this.size,
      this.handleClick
    );
    spawnHikari(this.positionIsoPlayer, this.size, this, this.counterGold);
    this.player.createAnimsPlayers(this);
    this.playerPrev = { x: this.player.x, y: this.player.y };
    spawnHomeTree(this.positionIsoHome, this.size, this);
    spawnLittleHouse(5, 2, this.size, this, "Moe");
    spawnLittleHouse(7, 2, this.size, this, "Homer");
    spawnLittleHouse(2, 5, this.size, this, "Bart", "right");
    spawnLittleHouse(2, 7, this.size, this, "Marge", "right");

    spawnLostFire(16, 3, this.size, this, "Moe");
    spawnLostFire(6, 9, this.size, this, "Bart");
    spawnLostFire(2, 18, this.size, this, "Homer");
    spawnLostFire(13, 17, this.size, this, "Marge");
    // this.newPNJ.createAnimsPnj(this);
    // this.pnjPrev = { x: this.newPNJ.x, y: this.newPNJ.y };

    generatePathGrid(
      this.config.map.layerGround,
      this.walkableGrid,
      this,
      this.tilesOutput
    );
    settingCameras(this);
  }

  update() {
    // Pos I / J du Player
    this.posPlayerI = isoToCoord(
      this.player.x,
      this.player.y,
      this.size.x,
      this.size.y
    ).i;
    this.posPlayerJ = isoToCoord(
      this.player.x,
      this.player.y,
      this.size.x,
      this.size.y
    ).j;
    // Update Z- Index Player
    this.player.setDepth(10 * this.posPlayerI + this.posPlayerJ + 0.5);
    this.player.updatePlayerOrientation(this);
    // this.newPNJ.updatePnjOrientation(this);
    // Check if the player is in a safe zone
    if (
      this.player.x >= 70 * -1 &&
      this.player.x <= 70 * 1 &&
      this.player.y >= 40 * 1 &&
      this.player.y <= 40 * 4
    ) {
      if (this.isSafe === false) {
        this.isSafe = true;
        this.config.setSafe();
        if (this.config.victory <= 0) {
          this.config.victoryCallBack();
        }
        if (this.victoryPrev != this.config.victory) {
          this.config.powerUp();
          this.victoryPrev = this.config.victory;
        }
      }
    } else {
      if (this.isSafe === true) {
        this.isSafe = false;
        this.config.setUnsafe();
      }
    }
    // Look for an event trigger
    if (this.triggers[`${this.posPlayerI}-${this.posPlayerJ}`]) {
      let ret = this.triggers[
        `${this.posPlayerI}-${this.posPlayerJ}`
      ].onTrigger();
      if (ret) {
        spawnLittleHouse(
          ret.i,
          ret.j,
          this.size,
          this,
          ret.name,
          ret.direction,
          true
        );
        this.config.victory--;
      }
      delete this.triggers[`${this.posPlayerI}-${this.posPlayerJ}`];
    }
  }

  handleClick() {
    // generatePathGridObstacle(this.scene.walkableGrid, this.scene, this.scene.tilesOutput);
    let from = isoToCoord(
      this.scene.player.x,
      this.scene.player.y,
      this.scene.size.x,
      this.scene.size.y
    );
    let fromX = Math.trunc(from.i);
    let fromY = Math.trunc(from.j);

    let to = isoToCoord(this.x, this.y, this.scene.size.x, this.scene.size.y);
    let toX = Math.trunc(to.i);
    let toY = Math.trunc(to.j);

    this.scene.finder.findPath(fromX, fromY, toX, toY, path => {
      if (path === null) {
        console.warn("Path was not found.");
      } else {
        this.scene.player.moveCharacter(path, this.scene);
      }
    });
    this.scene.finder.calculate();
  }
}
